import { useEffect, useState } from 'react';
import i18n, {
  supportedLngs,
  LS_LANG,
  changeLanguage,
  SupportedLngs,
} from '../../../i18n';
import { applyFont } from '../../../i18n';

export const useLanguage = () => {
  const [currentLang, setCurrentLang] = useState<string>(i18n.language);

  // Вызываем при монтировании и при смене языка
  useEffect(() => {
    const handleLangChange = () => {
      setCurrentLang(i18n.language);
      applyFont(i18n.language as SupportedLngs);
    };

    // Подписываемся на событие смены языка
    i18n.on('languageChanged', handleLangChange);

    // Читаем язык из localStorage при старте
    const lsLang = typeof window !== 'undefined' ? localStorage.getItem(LS_LANG) : null;
    if (lsLang && supportedLngs.includes(lsLang as SupportedLngs)) {
      changeLanguage(lsLang as SupportedLngs);
    }

    return () => {
      i18n.off('languageChanged', handleLangChange);
    };
  }, []);

  // Функция для смены языка через UI
  const setLanguage = (lng: SupportedLngs) => {
    if (supportedLngs.includes(lng)) {
      changeLanguage(lng);
      applyFont(lng);
    }
  };

  return { currentLang, setLanguage };
};
